/**
 * Beschriftungen des Monats-Editors: Titel der Auswahl und Platzhalter aus den gewählten,
 * geladenen Tagen („unverändert (98–118)“).
 */
import type { AvailabilityDistributionDay } from '@/shared/api';
import { weekdayShort } from '../calendar/calendarFormat';
import { parseIso } from '../calendar/calendarDates';
import { totalNights, type SelectedRange } from '../calendar/rangeSelectionModel';
import { MONTH_SHORT } from './monthModel';

/** „Do 29. Okt“ */
export function dayLabel(iso: string): string {
  const date = parseIso(iso);
  return `${weekdayShort(iso)} ${date.getUTCDate()}. ${MONTH_SHORT[date.getUTCMonth()]}`;
}

export function daysLabel(count: number): string {
  return count === 1 ? '1 Tag' : `${count} Tage`;
}

/** Ein Zeitraum mit Tagen, sonst die Zahl der Zeiträume und Tage. */
export function selectionTitle(ranges: readonly SelectedRange[]): string {
  if (ranges.length === 1) {
    const [range] = ranges;
    return range!.from === range!.to
      ? dayLabel(range!.from)
      : `${dayLabel(range!.from)} – ${dayLabel(range!.to)}`;
  }
  return `${ranges.length} Zeiträume · ${daysLabel(totalNights(ranges))}`;
}

export function editorPlaceholders(
  days: readonly AvailabilityDistributionDay[],
  ranges: readonly SelectedRange[],
): { pricePlaceholder: string; minStayPlaceholder: string } {
  const chosen = days.filter((day) =>
    ranges.some((range) => range.from <= day.date && range.to >= day.date),
  );
  const rates = chosen.flatMap((day) => (day.rate === null ? [] : [day.rate]));
  const stays = [...new Set(chosen.flatMap((day) => (day.minStay === null ? [] : [day.minStay])))];
  const low = Math.min(...rates);
  const high = Math.max(...rates);
  return {
    pricePlaceholder:
      rates.length === 0 ? 'unverändert' : `unverändert (${low === high ? low : `${low}–${high}`})`,
    minStayPlaceholder: stays.length === 1 ? `unverändert (${stays[0]})` : 'unverändert',
  };
}
